module.exports = __webpack_public_path__ + "static/media/service-business-mobile.e47069d0.png";